<template>
  <component
    :is="taggable ? 'v-combobox' : 'v-autocomplete'"
    v-bind="commonProps"
    :filled="filled"
    :multiple="multiple"
    :chips="chips"
    :small-chips="smallChips"
    :loading="loading"
    :item-text="getItemText"
    :item-value="getItemValue"
    :items="items || choices"
    :return-object="returnObject"
    :deletable-chips="deletableChips"
    :search-input.sync="keywordSearchstring"
    @change="
      (val) => {
        change(val);
        if (!keepSearchOnSelect) {
          keywordSearchstring = '';
        }
      }
    "
    @input="update"
  >
    <template v-if="$scopedSlots.selection" #selection="data">
      <!-- @slot Define a custom selection appearance -->
      <slot name="selection" v-bind="data"></slot>
    </template>
    <template v-if="$scopedSlots.item" #item="data">
      <!-- @slot Define a custom item appearance -->
      <slot name="item" v-bind="data"></slot>
    </template>
  </component>
</template>

<script>
import Input from '@ilteducation/vuetify-admin/src/mixins/input';
import Multiple from '@ilteducation/vuetify-admin/src/mixins/multiple';
import ReferenceInput from '@ilteducation/vuetify-admin/src/mixins/reference-input';

/**
 * Value editing from a searchable choices. Support multiple and references.
 * Allows searching of linked resources from your API.
 */
export default {
  mixins: [Input, Multiple, ReferenceInput],
  data() {
    return {
      keywordSearchstring: '',
    };
  },
  props: {
    /**
     * Value to be selected, array if multiple.
     * @model
     */
    value: {
      type: [String, Number, Array, Object],
      default: null,
    },
    /**
     * Minimum characters to tap before search query launch.
     */
    minChars: {
      type: Number,
      default: 3,
    },
    /**
     * Name of request query for searching into your API.
     */
    searchQuery: {
      type: String,
      default: 'q',
    },
    /**
     * Enable taggable mode. Transform autocomplete into combobox.
     */
    taggable: Boolean,
    /**
     * Returns whole object instead of single value.
     */
    returnObject: {
      type: Boolean,
      default: false,
    },
    deletableChips: {
      type: Boolean,
      default: false,
    },
    keepSearchOnSelect: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    input: {
      handler(newVal) {
        /**
         * Fetch full object as soon as we get input value
         */
        this.loadCurrentChoices(newVal);
      },
      immediate: true,
    },
  },
  mounted() {
    this.loadCurrentChoices();
  },
  methods: {
    async loadCurrentChoices(value) {
      if (this.reference && value) {
        this.items = await this.fetchCurrentChoices(this.multiple ? value : [value]);
      }
    },
    pushUpdate() {
      this.update(this.value);
    },
  },
};
</script>
